import { ChatRoomType } from 'features/chat/types';
import { FileNameMockResponseRoomList } from './MessageList.spec.cy';

export const MOCK_USER_LOGGED_IN = {
  id: 111,
  username: 'user-testing',
  country: 'ID',
};

// MessageIcon
export const DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT =
  'message-icon-inbox-chat-menu';
// MessageHeader
export const DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT =
  'message-header-inbox-chat-menu';
export const DATA_CY_NAME_MESSAGE_HEADER_REQUESTS =
  'message-header-inbox-chat-requests';
// MessageList
export const DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST =
  'message-header-inbox-chat-message-list';
export const DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY =
  'message-header-inbox-chat-message-list-empty';
// MessageItem
export const DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT =
  'message-item-inbox-chat-menu';
// MessageItemAvatar
export const DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT =
  'message-item-avatar-chat-menu';
// See All in Chat Button
export const DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON =
  'message-header-inbox-chat-see-all-button';

export const TEST_CASE_MESSAGE_COMPONENTS = (comp) => ({
  SHOULD_RENDER_SUCCESSFULLY: `Component ${comp} should render successfully`,
});

export const MOCK_COUNT_NOTIFICATION = {
  ZERO: 0,
  MORE_THAN_ZERO: 1,
  MORE_THAN_99: 100,
};

export const ROOM_LIST = {
  FILE_MOCK_NAME: {
    EMPTY: <FileNameMockResponseRoomList>'EmptyRoomList',
    ACCEPTED: <FileNameMockResponseRoomList>'AcceptedRoomList',
    INVITED: <FileNameMockResponseRoomList>'InvitedRoomList',
  },
};

export const MOCK_MESSAGE_ITEM = {
  id: 0,
  type: <ChatRoomType>'ROOM_TYPE_GROUP',
  info: {
    name: 'test lagi',
    shortened_name: 'TL',
    description: '',
    avatar_url: '',
  },
  attributes: {
    group: {
      member_description: '',
    },
  },
  unread_count: 0,
  last_message: {
    text: 'aaa',
    sender_username: 'sender_username',
    type: 'ATTACHMENT_TYPE_UNSPECIFIED',
    created_at: '2023-03-14T03:12:26Z',
    is_deleted: false,
    id: 1222222222,
  },
  status: {
    is_muted: false,
    is_mentioned: false,
  },
  state: 'ROOM_STATE_ACCEPTED',
  unread_message: {
    total: 0,
    last_id: 12,
  },
};
